// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityTypeId } from '../tbs/entity-type-id.js';


export class MapScriptEntWeight implements flatbuffers.IUnpackableObject<MapScriptEntWeightT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):MapScriptEntWeight {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsMapScriptEntWeight(bb:flatbuffers.ByteBuffer, obj?:MapScriptEntWeight):MapScriptEntWeight {
  return (obj || new MapScriptEntWeight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsMapScriptEntWeight(bb:flatbuffers.ByteBuffer, obj?:MapScriptEntWeight):MapScriptEntWeight {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new MapScriptEntWeight()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

etypeId():EntityTypeId {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EntityTypeId.Plain;
}

weight():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 1.0;
}

clobber():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
}

static startMapScriptEntWeight(builder:flatbuffers.Builder) {
  builder.startObject(3);
}

static addEtypeId(builder:flatbuffers.Builder, etypeId:EntityTypeId) {
  builder.addFieldInt16(0, etypeId, EntityTypeId.Plain);
}

static addWeight(builder:flatbuffers.Builder, weight:number) {
  builder.addFieldFloat64(1, weight, 1.0);
}

static addClobber(builder:flatbuffers.Builder, clobber:number) {
  builder.addFieldInt8(2, clobber, 0);
}

static endMapScriptEntWeight(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createMapScriptEntWeight(builder:flatbuffers.Builder, etypeId:EntityTypeId, weight:number, clobber:number):flatbuffers.Offset {
  MapScriptEntWeight.startMapScriptEntWeight(builder);
  MapScriptEntWeight.addEtypeId(builder, etypeId);
  MapScriptEntWeight.addWeight(builder, weight);
  MapScriptEntWeight.addClobber(builder, clobber);
  return MapScriptEntWeight.endMapScriptEntWeight(builder);
}

unpack(): MapScriptEntWeightT {
  return new MapScriptEntWeightT(
    this.etypeId(),
    this.weight(),
    this.clobber()
  );
}


unpackTo(_o: MapScriptEntWeightT): void {
  _o.etypeId = this.etypeId();
  _o.weight = this.weight();
  _o.clobber = this.clobber();
}
}

export class MapScriptEntWeightT implements flatbuffers.IGeneratedObject {
constructor(
  public etypeId: EntityTypeId = EntityTypeId.Plain,
  public weight: number = 1.0,
  public clobber: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return MapScriptEntWeight.createMapScriptEntWeight(builder,
    this.etypeId,
    this.weight,
    this.clobber
  );
}
}
